<template>
  <div :class="['page-title', { hasDate: date}, {hasExport: $slots.export || showExport}]">
    <h1 class="page-title__title">
      <slot></slot>
    </h1>
    <template v-if="$slots.export">
      <div class="page-title__export-wrapp">
        <slot name="export"></slot>
      </div>
    </template>
    <div v-else-if="showExport" class="page-title__export-wrapp">
      <el-dropdown class="page-title__export-icon el-dropdown" trigger="click" @command="handleHeaderDropdown">
        <span class="el-dropdown-link">
          <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 0V3.55654C16 4.02817 15.8127 4.48048 15.4793 4.81397C15.1459 5.14746 14.6937 5.33481 14.2222 5.33481H1.77778C1.30628 5.33481 0.854097 5.14746 0.520699 4.81397C0.187301 4.48048 0 4.02817 0 3.55654V0" transform="translate(1 11.6724)" stroke="#BFBFBF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.88889 4.44568L4.44444 0L0 4.44568" transform="translate(4.55566 1.00293)" stroke="#BFBFBF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M0 0V10.6696" transform="translate(9 1.00293)" stroke="#BFBFBF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="copyUrl">{{ $t('labels.copy_url') }}</el-dropdown-item>
          <!-- <el-dropdown-item command="pdf">{{ $t('labels.export_pdf') }}</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>

  export default {
    name: 'pageTitle',
    props: {
      date: {
        type: String,
        default: ''
      },
      showExport: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        dateChanged: ''
      }
    },
    methods: {
      copyUrl: function () {
        this.$copyText(window.location.href).then(
          // @ts-ignore
          () => { this.$message.success({message: this.$t('labels.copyied_to_clipboard')}) },
          // @ts-ignore
          () => { this.$message.warning({message: this.$t('labels.can_not_copy_url')}) }
        )
      },
      handleHeaderDropdown (command) {
        switch (command) {
          case 'pdf':
            this.makePdf();
            break;
          case 'copyUrl':
            this.copyUrl();
            break;
        }
      }
    },
    created () {}
  }
</script>
<style lang="scss">
@import 'src/assets/sass/core';

.page-title {
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 15px;
  margin-bottom: 20px;

  &.hasDate {
    grid-template-columns: 1fr 220px;

    @include  respond-to (phone) {
      grid-template-columns: 1fr;
    }
  }

  &.hasExport {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  &.hasExport.hasDate {
    grid-template-columns: 1fr 220px 70px;

    @include  respond-to (phone) {
      grid-template-columns: 1fr 70px;
    }
  }

  &__date{
    font-size: 10px;
    color: #A6A6A6;
    font-weight: 300;
    margin-left: 2px;
    margin-top: 3px;
    align-self: start;
    text-align: right;

    @include  respond-to (phone) {
      order: 3;
      text-align: left;
    }
  }
  &__title {
    padding-bottom: 5px;
    margin: 0 0 0 2px;
    font-size: 28px;
    font-weight: 700;
    color: #000;
    word-break: break-word;

    @include  respond-to (phone) {
      font-size: 20px;
    }
  }

  &__export-wrapp {
    display: flex;
    align-self: start;
    justify-self: right;
  }

  &__export-icon {
    margin-left: 20px;
    cursor: pointer;

    @media (max-width: 480px){
      margin-left: 10px;
    }

    &:first-child {
      margin-left: 0;
    }

    &:hover {
      svg path {
        stroke: $link-color;
      }
    }

    .el-dropdown-link {
      &:focus {
        outline: 0;
      }
    }
  }
}
</style>